import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  KRÉTA-FELJEGYZÉSEK – szinkron (admin).
 *
 *  A KRÉTA a feljegyzéseket (határozat, törzslapra kerülő feljegyzés, figyelmeztetés…) és a
 *  tantárgyi felmentéseket az „Adminisztrációs rendszer" szerepkörben listázza. A szinkron egy
 *  már felvett KRÉTA-fiókkal lép be, letölti mindkettőt, és beírja: a feljegyzéseket abba a
 *  nyilvántartásba, amit a tanárok, az osztályfőnök és a szülők is látnak, a felmentéseket a
 *  napló névsorához. A KRÉTÁ-ba NEM ír.
 *
 *  Itt látszik az is, mi vár visszaírásra, és a visszaíró SZÁRAZ futása: tételenként a KRÉTA-
 *  kérés, amit elküldene – az éles küldés jóváhagyásig ki van kapcsolva.
 */
@Component({
  selector: 'app-admin-kreta-feljegyzes',
  templateUrl: './kreta-feljegyzes.component.html',
  styleUrls: ['./kreta-feljegyzes.component.scss'],
})
export class KretaFeljegyzesComponent implements OnInit, OnDestroy {
  intezmeny = '';
  toltodik = true;
  hiba = '';

  b: { forras_allomany: string; automatikus: boolean; visszairas_auto: boolean } = { forras_allomany: '', automatikus: false, visszairas_auto: false };
  kuld = false;
  fiokok: { allomany: string; tanar_nev: string; kreta_user: string }[] = [];
  futasok: any[] = [];
  osszesito: any = null;
  felmentes: any = null;
  tipusok: any = null;
  parositatlan: any[] = [];
  felmentesParositatlan: any[] = [];
  visszairando: any[] = [];
  elesitve = false;

  /** A visszaíró száraz futásának eredménye (tételenként a KRÉTA-kérés). */
  terv: any[] | null = null;
  tervToltodik = false;
  nyitottTerv: { [id: string]: boolean } = {};

  folyamat: any = null;
  ment = false;
  private idozito: any = null;

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    await this.betolt();
  }

  ngOnDestroy() { if (this.idozito) clearInterval(this.idozito); }

  async betolt() {
    this.toltodik = !this.futasok.length;
    this.hiba = '';
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/kreta-feljegyzes/beallitas/${this.intezmeny}`));
      this.b = { forras_allomany: r?.forras_allomany || '', automatikus: !!r?.automatikus, visszairas_auto: !!r?.visszairas_auto };
      this.fiokok = r?.fiokok || [];
      this.futasok = r?.futasok || [];
      this.osszesito = r?.osszesito || null;
      this.felmentes = r?.felmentes || null;
      this.tipusok = r?.tipusok || null;
      this.parositatlan = r?.parositatlan || [];
      this.felmentesParositatlan = r?.felmentes_parositatlan || [];
      this.visszairando = r?.visszairando || [];
      this.elesitve = !!r?.visszairas_elesitve;
      this.folyamat = r?.folyamat || null;
      if (this.folyamat?.fut) this.kovet();
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A beállítás nem tölthető be.';
    } finally {
      this.toltodik = false;
    }
  }

  async mentes() {
    this.ment = true;
    try {
      await firstValueFrom(this.http.put(`/api/kreta-feljegyzes/beallitas/${this.intezmeny}`, this.b));
      this.data.sendToast('Beállítás mentve.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.ment = false;
    }
  }

  async szinkron() {
    if (!this.b.forras_allomany) {
      this.data.sendToast('Válaszd ki, melyik KRÉTA-fiókkal lépjen be a szinkron.', 'warning');
      return;
    }
    if (!confirm('Elindítod a szinkront? A rendszer belép a KRÉTÁ-ba, letölti a feljegyzéseket és a '
      + 'tantárgyi felmentéseket, és frissíti az itteni nyilvántartást. A KRÉTÁ-ban nem változtat semmit.')) return;
    try {
      await firstValueFrom(this.http.put(`/api/kreta-feljegyzes/beallitas/${this.intezmeny}`, this.b));
      const r: any = await firstValueFrom(this.http.post(`/api/kreta-feljegyzes/szinkron/${this.intezmeny}`, {
        forras_allomany: this.b.forras_allomany,
      }));
      this.folyamat = r?.folyamat || { fut: true, lepes: 'Indul' };
      this.kovet();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A szinkron nem indult el.', 'error');
    }
  }

  /*  A szinkron fél perctől pár percig tart: a képernyő mutassa, hol tart. */
  private kovet() {
    if (this.idozito) clearInterval(this.idozito);
    this.idozito = setInterval(async () => {
      try {
        const r: any = await firstValueFrom(this.http.get(`/api/kreta-feljegyzes/szinkron-allapot/${this.intezmeny}`));
        this.folyamat = r;
        if (!r?.fut) {
          clearInterval(this.idozito);
          this.idozito = null;
          if (r?.hiba) this.data.sendToast(`A szinkron nem sikerült: ${r.hiba}`, 'error');
          else if (r?.eredmeny) this.data.sendToast('A szinkron kész.', 'success');
          await this.betolt();
          if (this.terv) await this.szarazFutas();
        }
      } catch { /* a következő körben újra kérdezzük */ }
    }, 2500);
  }

  /** A visszaíró száraz futása: mit küldene a KRÉTÁ-ba – a KRÉTÁ-hoz nem kapcsolódik. */
  async szarazFutas() {
    this.tervToltodik = true;
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/kreta-feljegyzes/visszairas-terv/${this.intezmeny}`));
      this.terv = r?.terv || [];
      this.elesitve = !!r?.elesitve;
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A száraz futás nem sikerült.', 'error');
    } finally {
      this.tervToltodik = false;
    }
  }

  /** A küldhető tételek azonnali kiküldése (a rögzítők saját KRÉTA-fiókjával). */
  async kuldesMost() {
    if (!confirm('Kiküldöd a küldhető feljegyzéseket a KRÉTÁ-ba? A rendszer a rögzítő tanár fiókjával lép be, '
      + 'és tételenként a KRÉTA Beírások ablakán át ment.')) return;
    this.kuld = true;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/kreta-feljegyzes/visszairas/${this.intezmeny}`, {}));
      this.data.sendToast(`Elküldve: ${r?.elkuldve || 0}, hiba: ${r?.hiba || 0}.`, r?.hiba ? 'warning' : 'success');
      await this.betolt();
      if (this.terv) await this.szarazFutas();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A küldés nem sikerült.', 'error');
    } finally {
      this.kuld = false;
    }
  }

  muveletNev(m: string): string {
    return m === 'torles' ? 'törlés' : (m === 'modositas' ? 'módosítás' : 'új feljegyzés');
  }

  json(x: any): string { return JSON.stringify(x, null, 2); }
}
